import type { IconSvgObject } from './types';

const WifiSyncIcon: IconSvgObject = [
  ["path", { d: "M2 7.81966C4.75011 5.35989 8.31034 4 12 4C15.6897 4 19.2499 5.35989 22 7.81966M5 11.8587C6.38599 10.5001 8.12597 9.58466 10 9.20209M8.5 15.4287C8.93844 14.9989 9.44772 14.6578 10 14.4168", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.4649 13.5C20.7733 12.3044 19.4806 11.5 18 11.5C16.4726 11.5 15.1451 12.3561 14.4713 13.6147M14.5351 17.5C15.2267 18.6956 16.5194 19.5 18 19.5C19.5227 19.5 20.8467 18.6492 21.5224 17.397M17 14H14V11M19 17H22V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WifiSyncIcon;
